export interface Wallet {
    id: number;
    amount: string;
    currency_code: string;
    non_cash_amount: string;
    owner_id: number;
    owner_type: string;
    winning_amount: string;
    created_at: string;
    updated_at: string;
}
